import React from 'react';
import '../Complexes/ResidentialComplexList.css';

export default function IncidentBadge({ icon, count = 0, alert = false, title }) {
  const display = count > 99 ? '99+' : count;
  return (
    <span className={`rc-chip ${alert ? 'rc-chip--alert' : ''}`} title={title}>
      <span className="rc-chip__icon" aria-hidden="true">
        {icon ? <img src={icon} alt="" /> : null}
      </span>
      <span className="rc-chip__count">{display}</span>
    </span>
  );
}
